import { gql } from '@apollo/client';

export const GET_HUB_DELIVERABLE_ZIPCODES = gql`
  query GetHubDeliverableZipcodes($hubId: Long!) {
    getHubDeliverableZipcodes(hubId: $hubId) {
      hubId
      zipcodes
      totalCount
    }
  }
`;

export interface HubDeliverableZipcodeOutput {
  hubId: number;
  zipcodes: string[];
  totalCount: number;
}

export interface GetHubDeliverableZipcodesResponse {
  getHubDeliverableZipcodes: HubDeliverableZipcodeOutput;
}

export interface GetHubDeliverableZipcodesVariables {
  hubId: number;
}

